import { StatusEnum } from '@/types/cart';
import { ProductCardProps } from '../../types';
import CardBodyProductClaimedLanding from './card-body-product-claimed';
import CardBodyProductClaimedPersonalized from './product-claimed';

/**
 * 优先展示 coupon landing 领取态（claim_desc）；否则再展示个性化券领取态。
 */
export default function ProductClaimedPriority(props: Partial<ProductCardProps>) {
  const { data } = props;
  const { copywriting, sold_status } = data || {};

  if (sold_status && [StatusEnum.sold_out, StatusEnum.change_other_day].includes(sold_status as StatusEnum)) {
    return null;
  }

  if (copywriting && copywriting.claim_desc) {
    return <CardBodyProductClaimedLanding {...props} />;
  }

  return <CardBodyProductClaimedPersonalized {...props} />;
}
